// extracted by mini-css-extract-plugin
export default {"AppMenu":"AppMenuMobile_AppMenu__1-rMA","AppMenuFooter":"AppMenuMobile_AppMenuFooter__vmsW+"};